import React from "react";
import { connectToState } from "../redux/connect-api";
import { bool, shape, string } from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Link as MaterialLink } from "@mui/material";
import { platformConfig } from "shared/platform/config";
import { alpha } from "@mui/material/styles";
import googleAnalytics from "shared/analytics";
import { Link } from "react-router";
import useThrottledOnScroll from "../hooks/useThrottleScroll";

const ToolTabs = ({
  loading = true,
  toolAccess = {
    ecAccess: false,
    imAccess: false,
  },
  showAlways = true,
  showActiveTab = true,
  location,
}) => {
  const { tools } = platformConfig;
  const [tabsVisible, showTabs] = React.useState(false);

  // Check if we're on the tools page - tabs should always be visible there
  const isToolsPage = location?.pathname === "/tools";

  useThrottledOnScroll(
    () => {
      const container = document.getElementById("scroll-container");
      if (!container) return;
      showTabs(container.scrollTop > 800);
    },
    { delay: 500 },
  );

  const tabsStyle = { opacity: 1 };
  // Only hide if not on tools page AND not showAlways AND not scrolled
  if (!isToolsPage && !showAlways && !tabsVisible) {
    tabsStyle.opacity = 0;
  }

  if (loading) return null;

  return (
    <>
      <Tabs
        value={showActiveTab ? tools[0].id : false}
        aria-label="ICER Tools"
        textColor="secondary"
        indicatorColor="secondary"
        sx={(theme) => ({
          transition: ".25s opacity ease-in-out",
          // Show by default on tools page, otherwise follow the existing logic
          opacity: isToolsPage ? 1 : 0,
          display: "none",
          [theme.breakpoints.up("lg")]: {
            display: "flex",
          },
          "& .MuiTabs-scroller": {
            display: "flex",
            alignItems: "stretch",
          },
          "& .MuiTabs-indicator": {
            height: 3,
          },
        })}
        style={tabsStyle}
      >
        {tools.map(({ id, name, href, to }, i) => (
          <Tab
            value={id}
            label={name}
            component={to ? Link : MaterialLink}
            href={href}
            to={to}
            sx={(theme) => ({
              color: theme.palette.secondary.main,
              textDecoration: "none",
              "&:hover,&:focus": {
                background: alpha(theme.palette.secondary.main, 0.1),
                textDecoration: "none",
              },
              "&.Mui-selected": {
                pointerEvents: "none",
                fontWeight: 600,
              },
            })}
            disabled={!toolAccess[`${id}Access`]}
            key={i}
            onClick={() => googleAnalytics.trackHeaderNav({ action: "tab", label: name })}
            tabIndex={showAlways || tabsVisible ? 0 : -1}
          />
        ))}
      </Tabs>
    </>
  );
};

ToolTabs.propTypes = {
  loading: bool,
  toolAccess: shape({
    ecAccess: bool,
    imAccess: bool,
  }),
  location: shape({
    pathname: string,
  }),
  showAlways: bool,
  showActiveTab: bool,
};

const mapStateToProps = (state) => {
  return {
    loading: state.userProfile.loading,
    toolAccess: {
      ecAccess: state.userProfile.data.ec_access,
      imAccess: state.userProfile.data.im_access,
    },
  };
};

export default connectToState(mapStateToProps)(ToolTabs);
